import { createStyles } from '@mui/styles'

const styles = createStyles(() => ({
}))

export default styles
